import { createApi } from '@reduxjs/toolkit/query/react';

import baseQueryWithReauth from './endpoints/baseQueryWithReauth';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'AccountPreferences',
    'AgentLicenses',
    'AgencyLicenses',
    'AgencyAgent',
    'AgencyAgents',
    'AgencyNotification',
    'BrokerPositions',
    'DrpCoverageRequests',
    'DrpOperationQuotes',
    'LrpCoverageRequestEndorsements',
    'LrpCoverage',
    'OperationInfo',
    'OperationPreferences',
    'DrpCoverageRequestEndorsements',
    'DrpEndorsements',
    'DrpEndorsementSummaries',
    'LrpEndorsements',
    'LrpEndorsementSummaries',
    'LrpCashRevenuePreferences',
    'LrpSalesSettings',
    'CoverageRequests',
    'DrpCoverageRequest',
    'LrpCoverageRequests',
    'LgmDairyQuoter',
    'Tags',
    'TagTypes',
    'AipOperations',
    'AipStatus',
    'LgmCattleAipEndorsements',
    'LgmEstimates',
    'LgmCattleWhatIf',
    'LgmCattleSummary',
    'LgmCattleEndorsement',
    'PriceReport',
    'DrpAlerts',
    'Stakeholders',
    'Producers',
    'OperationProduction',
    'LrpPriceTrends'
  ],
  endpoints: () => ({})
});
